import { BreakCommon } from "./BreakCommon";
import { kDefaultBreakChars } from "../constants";

export function BreakContentList(theContent, availableWidth, leftMargin, rightMargin, fontString) {
  var contentRows = theContent.split("|");
  var numRows = contentRows.length;

  var finalRows = [];
  availableWidth = availableWidth - (rightMargin + leftMargin);
  var regStr = "[" + kDefaultBreakChars + "]";
  var re = new RegExp(regStr);

  for (var i = 0; i < numRows; i++) {
    var theContent = contentRows[i];
    BreakCommon(theContent, re, availableWidth, fontString, 1000, finalRows);
  }

  return finalRows;
}
